import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchWarehouseVehicleSetupActions as Actions,
  FetchWarehouseVehicleSetupRequestAction as RequestAction,
} from 'store/ducks/warehouseVehicleSetups';

export function* fetchWarehouseVehicleSetupRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, `warehouse-vehicle-setups/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
